import axios from "axios";
export const state = {
  categories: [],
  v_revenues: [],
  report: [],
  save_status: false,
};
export const getters = {
  Categories: (state) => state.categories.data,
  Revenues: (state) => state.v_revenues.data,
  Report: (state) => state.report,
  SaveStatus: (state) => state.save_status,
};

export const mutations = {
  SET_CATS(state, newValue) {
    state.categories = newValue;
  },
  SET_REVENUES(state, newValue) {
    state.v_revenues = newValue;
  },
  SET_REPORT(state, newValue) {
    state.report = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
};

export const actions = {
  addRevCategory({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("revenue_categories", payload)
      .then(() => {
        dispatch("fetchRevCategories");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Edit  Set
  editRevCategory({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`revenue_categories/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchRevCategories");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Delete Set
  deleteRevCategory({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`revenue_categories/${payload.id}`)
      .then(() => {
        dispatch("fetchRevCategories");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },

  addRevenue({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("revenues", payload)
      .then(() => {
        dispatch("fetchRevenues");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Edit  Set
  editRevenue({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`revenues/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchRevenues");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Delete Set
  deleteRevenue({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`revenues/${payload.id}`)
      .then(() => {
        dispatch("fetchRevenues");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },

  fetchRevCategories({ commit }) {
    axios.get("revenue_categories").then((pos) => {
      commit("SET_CATS", pos.data);
    });
  },
  fetchRevenues({ commit }) {
    axios.get("revenues").then((sta) => {
      commit("SET_REVENUES", sta.data);
    });
  },
  fetchReport({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("revenue_report", payload)
      .then((sta) => {
        commit("SET_REPORT", sta.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
};
